import React from 'react';
import { Loader, AccountConfirmation, AccountConfirmationProps } from 'components';
import { Redirect } from 'react-router';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';

const AccountConfirmationContainer = ({
    apiError, cleanErrors, token, checkAccountConfirmationToken, confirmAccount, onPush, auth, authProcessing,
}: Props) => {
    if (auth && auth.profile) return <Redirect to="/" />;

    if (authProcessing) return <Loader />;

    const [tokenProcessing, setTokenProcessing] = React.useState(true);

    React.useEffect(() => {
        const checkToken = async () => {
            setTokenProcessing(true);
            await checkAccountConfirmationToken(token);
            setTokenProcessing(false);
        };

        checkToken();
    }, []);

    const handleSubmit = async (password: string) => {
        await confirmAccount({
            password,
            token,
        });
    };

    if (tokenProcessing) {
        return <Loader />;
    }

    const createConfirmationProps: AccountConfirmationProps = {
        handleSubmit,
        apiError,
        authProcessing,
        cleanErrors,
        onLogin: () => onPush('/'),
    };

    return <AccountConfirmation {...createConfirmationProps} />;
};

interface IProps {
    token: string;
}

const mapState = (state: IRootState) => ({
    apiError: state.errors.error,
    auth: state.auth,
    authProcessing: Boolean(state.loading.effects.auth.fetchProfile),
});

const mapDispatch = (dispatch: Dispatch) => ({
    onPush: (key: string) => dispatch(push(key)),
    cleanErrors: dispatch.errors.clean,
    checkAccountConfirmationToken: dispatch.auth.checkAccountConfirmationTokenAsync,
    confirmAccount: dispatch.auth.confirmAccountAsync,
});

type connectedProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>
type Props = connectedProps & IProps;

export default connect(mapState, mapDispatch)(AccountConfirmationContainer);
